import { useLocation, useNavigate } from 'react-router-dom';
import { ViewSwitch } from '../ui/ListToolbar';
import { useDossierRegistrySettings } from '../../hooks/queries/useCabinetSettings';
import {
  dossierRegisterPath,
  parseDossierRegisterView,
} from './dossierRegisterView';

const VIEWS = [
  {
    value: 'list',
    label: 'Liste',
    icon: (
      <svg viewBox="0 0 512 512" fill="currentColor" aria-hidden>
        {/* Font Awesome Pro 6.5.1 — list regular */}
        <path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z" />
      </svg>
    ),
  },
  {
    value: 'kanban',
    label: 'Kanban',
    icon: (
      <svg viewBox="0 0 448 512" fill="currentColor" aria-hidden>
        {/* Font Awesome Pro 6.5.1 — square-kanban regular */}
        <path d="M64 432c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zM128 288c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24zm168 40c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24s-24 10.7-24 24V328zm-72-72c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24z" />
      </svg>
    ),
  },
] as const;

/** Bascule Liste / Kanban du registre, dans la barre d'outils de la page. */
export function DossierViewSelect() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const view = parseDossierRegisterView(pathname);
  const { data: registry } = useDossierRegistrySettings();
  // Vue en colonnes désactivée au cabinet : plus de bascule, la liste seule.
  if (!view || registry?.board !== true) return null;

  return (
    <ViewSwitch
      label="Vue des dossiers"
      options={VIEWS}
      value={view}
      onChange={(next) => navigate(dossierRegisterPath(next))}
    />
  );
}
